var CompaniesController = /** @class */ (function () {
    /*@ngInject*/
    function CompaniesController($rootScope, $state, $timeout, moment, companyService, planService, userRoleService, utilityService, StorageService, stateManagementStorageService, MESSAGECONSTANTS, userService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.moment = moment;
        this.companyService = companyService;
        this.planService = planService;
        this.userRoleService = userRoleService;
        this.utilityService = utilityService;
        this.StorageService = StorageService;
        this.stateManagementStorageService = stateManagementStorageService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.userService = userService;
    }
    CompaniesController.prototype.$onInit = function () {
        this.companies = [];
        this.searchTerm = '';
        this.showLogoutButtonInPopup = false;
        this.companyListLoaded = false;
        this.disableLogoutButton = true;
        this.isSuperUser = this.userRoleService.isLoggedInUserSuperUser();
        this._getAllCompanies();
    };
    CompaniesController.prototype._getAllCompanies = function () {
        var _this = this;
        this.companyService.getAllCompanies(function (data) {
            if (data.length == 0) {
                _this.showLogoutButtonInPopup = true;
            }
            _this.companies = [];
            data.forEach(function (company) {
                if (!_this._checkCompanyExists(company)) {
                    company.companyStateLabel = company.companyState == 'SoftHold' ? 'Soft Hold' : company.companyState;
                    _this.companies.push(company);
                }
            });
            _this.companyListLoaded = true;
            _this.$timeout(function () {
                _this.disableLogoutButton = false;
            }, 2000);
            if (typeof callback != "undefined") {
                return callback(_this.companies);
            }
        }, function (error) {
            _this.$rootScope.throwError(error);
            if (typeof callback != "undefined") {
                return callback("done");
            }
        });
    };
    CompaniesController.prototype.getCompany = function (company) {
        this.searchTerm = '';
        this.$rootScope.companyDeletedShowPopup = false;
        this.$rootScope.SelectedCompanyId = company.companyId;
        this.$rootScope.CompanySelectedFromPopup = true;
        this.$rootScope.showNotificationsIcon = false;
        if (this.StorageService.get('SelectedHostCompany') != null) {
            this.StorageService.set('SelectedHostCompany', null);
        }
        if (company.companyType == 'Host') {
            this.StorageService.set('SelectedHostCompany', company);
        }
        else {
            this.StorageService.set('companyDetails', company);
        }
        this.$rootScope.userDetails.company.companyId = company.companyId;
        this.$rootScope.userDetails.company.companyName = company.companyName;
        this.$rootScope.userDetails.company.companyType = company.companyType;
        this.$rootScope.userDetails.company.companyState = company.companyState;
        this.companyService.setCompanyStateLabel();
        this.stateManagementStorageService.clearStatesOfScreens();
        this.$rootScope.userDetails.company.companySelected = true;
        this.getPlan(company.companyId);
    };
    CompaniesController.prototype.getPlan = function (companyId) {
        var _this = this;
        this.utilityService.showLoadingModal("Loading...");
        this.planService.getCurrentPlan(companyId, function (data) {
            if (data !== "" && data !== null) {
                _this.$rootScope.userDetails.plan.planName = data.planHeaderDto.planName;
                _this.$rootScope.userDetails.plan.startDate = _this.moment(data.planHeaderDto.planStartDate);
                _this.$rootScope.userDetails.plan.endDate = _this.moment(data.planHeaderDto.planEndDate);
                _this.$rootScope.userDetails.plan.planType = data.planHeaderDto.planType;
            }
            _this.StorageService.set('userDetails', _this.$rootScope.userDetails, { 'expires': new Date(Date.now() + _this.$rootScope.tokenvalidity) });
            _this.$rootScope.switchClicked = false;
            _this.$rootScope.$emit("CompanySwitched");
            _this.destroyModal();
            _this.$timeout(function () {
                if (_this.$rootScope.userDetails.roleScreenRef.role.name === '4dot5SuperUser' && _this.$rootScope.userDetails.company.companyType === 'Host') {
                    _this.$state.go('missioncontrol.companymanagement', { 'selectedCompanyId': companyId, 'vendorId': null, 'clientOrBuObject': null }, { reload: true });
                }
                else {
                    if (_this.StorageService.get('companyDetails') != null && _this.$rootScope.userDetails.company.companyState == 'Active') {
                        if (_this.$rootScope.userDetails.plan.planName !== 'Vendor Only') {
                            _this.$state.go('missioncontrol.dashboard', null, { reload: true });
                        }
                        else {
                            _this.$state.go('missioncontrol.requisitions', null, { reload: true });
                        }
                    }
                    else {
                        _this.$state.go('missioncontrol.companymanagement', { clientOrBuObject: null, vendorId: null, clientOrBuObject: null }, { reload: true });
                    }
                }
                _this.utilityService.hideLoadingModal();
                var userCacheObject = {
                    userId: _this.$rootScope.userDetails.id,
                    loggedInCompanyId: _this.$rootScope.userDetails.company.companyId
                };
                // Invoke user cache in order to save the users in in-memory-cache.
                _this.userService.userCache(userCacheObject, function () { }, function (error) { console.log(error); });
            }, 500);
            _this.$rootScope.showNotificationsIcon = true;
        }, function (error) {
            _this.$rootScope.throwError(error);
            if (typeof callback != "undefined") {
                return callback("done");
            }
        });
    };
    CompaniesController.prototype.destroyModal = function () {
        this.$rootScope.switchCompanyRepeat = 0;
        this.$rootScope.switchClicked = false;
        this.closeModal();
    };
    CompaniesController.prototype.addCompany = function () {
        this.destroyModal();
        this.$rootScope.companyDeletedShowPopup = false;
        this.StorageService.remove('companyDetails');
        this.StorageService.remove('SelectedHostCompany');
        this.$rootScope.userDetails.company.companyId = null;
        this.$rootScope.userDetails.company.companyName = null;
        this.$rootScope.userDetails.company.companyType = null;
        this.$rootScope.userDetails.company.companyState = 'Draft';
        this.companyService.setCompanyStateLabel();
        this.$rootScope.userDetails.company.companySelected = false;
        this.StorageService.set('userDetails', angular.copy(this.$rootScope.userDetails), { 'expires': new Date(Date.now() + this.$rootScope.tokenvalidity) });
        this.$state.go('missioncontrol.companymanagement', { companyObject: this.$rootScope.userDetails.company }, { reload: true });
    };
    CompaniesController.prototype.logoutAsNoCompaniesRelated = function () {
        var _this = this;
        this.destroyModal();
        this.$timeout(function () {
            _this.$rootScope.$emit("CallLogoutMethod");
        }, 200);
    };
    ;
    //method
    CompaniesController.prototype.dismissModalAndDestroy = function () {
        this.$rootScope.switchClicked = false;
        this.destroyModal();
    };
    CompaniesController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    CompaniesController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    CompaniesController.prototype._checkCompanyExists = function (element) {
        for (var i = 0; i < this.companies.length; i++) {
            if ((this.companies[i].companyId === element.companyId) && (this.companies[i].companyName === element.companyName)) {
                return true;
            }
        }
        return false;
    };
    ;
    return CompaniesController;
}());
CompaniesController.$inject = ['$rootScope', '$state', '$timeout', 'moment', 'companyService', 'planService', 'userRoleService', 'utilityService', 'StorageService', 'stateManagementStorageService', 'MESSAGECONSTANTS', 'userService'];
// import * as TEMPLATE from './companies.html';
import * as TEMPLATE from 'raw-loader!./companies.html';
export var CompaniesComponent = {
    selector: 'companies',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: CompaniesController,
        // templateUrl: 'app/shared/companies/companies.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=companies.component.js.map